var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewBill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.907,
    height: 63.975,
    viewBox: "0 0 48.907 63.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.772,25.28l-3.969,4.2a6.153,6.153,0,0,0,0,8.386,5.425,5.425,0,0,0,7.955,0,6.153,6.153,0,0,0,0-8.386Z",
    transform: "translate(13.179 16.532)",
    fill: "#efc700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.924,10.238H22.241a1.654,1.654,0,1,0,0-3.308H4.924a1.654,1.654,0,1,0,0,3.308Z",
    transform: "translate(2.138 4.532)",
    fill: "#1787e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.288,21.834a1.654,1.654,0,0,0-1.654-1.654H4.924a1.654,1.654,0,0,0,0,3.308h24.71A1.654,1.654,0,0,0,31.288,21.834Z",
    transform: "translate(2.138 13.197)",
    fill: "#1787e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,10.238a1.654,1.654,0,0,0,0-3.308H18.934a1.654,1.654,0,0,0,0,3.308Z",
    transform: "translate(11.3 4.532)",
    fill: "#1787e0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.924,18.7H9.886a1.654,1.654,0,1,0,0-3.308H4.924a1.654,1.654,0,1,0,0,3.308Z",
    transform: "translate(2.138 10.065)",
    fill: "#1787e0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.984,15.39a1.654,1.654,0,1,0,0,3.308h4.962a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(5.447 10.065)",
    fill: "#1787e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.924,26.49a1.654,1.654,0,0,0,0,3.308H9.886a1.654,1.654,0,0,0,0-3.308Z",
    transform: "translate(2.138 17.323)",
    fill: "#1787e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.24,28H16.031a1.654,1.654,0,0,0-1.191,2.8,1.654,1.654,0,0,0,1.191,2.8H19.24a1.654,1.654,0,0,0,1.125-2.746A1.654,1.654,0,0,0,19.24,28Z",
    transform: "translate(9.406 18.311)",
    fill: "#efc700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.38,17.044A1.654,1.654,0,0,0,15.034,18.7H26.3a1.654,1.654,0,0,0,0-3.308H15.034A1.654,1.654,0,0,0,13.38,17.044Z",
    transform: "translate(8.75 10.065)",
    fill: "#1787e0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.924,14.138H22.241a1.654,1.654,0,1,0,0-3.308H4.924a1.654,1.654,0,1,0,0,3.308Z",
    transform: "translate(2.138 7.083)",
    fill: "#1787e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.312,9.328A1.654,1.654,0,0,0,46.922,9a4.565,4.565,0,0,1-4.168-1.29,5.723,5.723,0,0,1-1.522-5.177l.116-.562A1.647,1.647,0,0,0,39.695,0H1.654A1.654,1.654,0,0,0,0,1.654V62.321a1.654,1.654,0,0,0,1.654,1.654H36.982a1.654,1.654,0,1,0,0-3.308H3.308V3.308H37.826a8.9,8.9,0,0,0,2.6,6.748A7.989,7.989,0,0,0,45.6,12.388V58.335a1.654,1.654,0,0,0,3.308,0V10.618A1.654,1.654,0,0,0,48.312,9.328Z",
    transform: "translate(0 0)",
    fill: "#1787e0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBill);
export default __webpack_public_path__ + "static/media/view_bill.b52c284d7bf548369bb8126ec58d770f.svg";
export { ForwardRef as ReactComponent };